<template>
  <div class="swiper-inner">
    <!-- swiper -->
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide>
        <div class="swDivOne" @click="now(0)">
          <div class="spanOne">
            <span>{{ $tc('lang.qaQcService.Final_Inspection') }}</span>
            <p>
              {{ $tc('lang.qaQcService.Final_Inspection_text') }}
            </p>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="swDivTow" @click="now(1)">
          <div class="spanTow">
            <span>{{
              $tc('lang.qaQcService.During_Production_Inspection')
            }}</span>
            <p>
              {{ $tc('lang.qaQcService.During_Production_Inspection_text') }}
            </p>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="swDivThree" @click="now(2)">
          <div class="spanThree">
            <span>{{ $tc('lang.qaQcService.Loading_Supervision') }}</span>
            <p>
              {{ $tc('lang.qaQcService.Loading_Supervision_text') }}
            </p>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
export default {
  name: 'awesomeSwiper',
  data() {
    return {
      swiperOption: {
        // autoplay: true,
        initialSlide: 1,
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
    now(value) {
      this.swiper.slideTo(value);
    },
  },
};
</script>

<style lang="less">
.swiper-inner {
  width: 100%;
  height: 500px;
  padding-top: 50px;
  padding-bottom: 50px;
}
.swiper-wrapper {
  height: 630px;
}
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: -1px;
}
.swiper-slide {
  background-position: center;
  background-size: cover;
  width: 460px;
  height: 300px;
  border-radius: 10px;
  margin-top: 10px;
  box-shadow: 0 2px 12px 0 #e1e2e2;
}
.swDivOne {
  width: 100%;
  /*text-align: left;*/
  /*display: -webkit-box;*/
  height: 340px;
  background-image: url('../image/productService1.jpg');
  border-radius: 5px;
  background-size: cover;
  .spanOne {
    padding-top: 350px;
    > span {
      /*color: #ffffff;*/
      font-size: 20px;
      font-weight: 600;
    }
    > p {
      /*color: #00baad;*/
      padding-top: 2px;
      text-indent: 3em;
      text-align: left;
      font-size: 18px;
      margin-left: 15px;
      margin-right: 15px;
    }
  }
}
.swDivTow {
  width: 100%;
  /*text-align: left;*/
  /*display: -webkit-box;*/
  height: 340px;
  background-image: url('../image/productService2.jpg');
  border-radius: 5px;
  background-size: cover;
  .spanTow {
    padding-top: 350px;
    > span {
      /*color: #ffffff;*/
      font-size: 20px;
      font-weight: 600;
    }
    > p {
      /*color: #00baad;*/
      padding-top: 2px;
      text-indent: 3em;
      text-align: left;
      font-size: 18px;
      margin-left: 15px;
      margin-right: 15px;
    }
  }
}
.swDivThree {
  width: 100%;
  /*text-align: left;*/
  /*display: -webkit-box;*/
  height: 350px;
  background-image: url('../image/productService3.jpg');
  border-radius: 10px;
  background-size: cover;
  .spanThree {
    padding-top: 360px;
    > span {
      /*color: #ffffff;*/
      font-size: 20px;
      font-weight: 600;
    }
    > p {
      /*color: #00baad;*/
      padding-top: 2px;
      text-indent: 3em;
      text-align: left;
      font-size: 18px;
      margin-left: 15px;
      margin-right: 15px;
    }
  }
}
</style>
